var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { staticClass: "cobrowsing__container", attrs: { height: "100%" } },
    [
      _vm.loadingMirroring
        ? _c(
            "div",
            { staticClass: "wz_loadingCobrowsing text-xs-center" },
            [
              _c("v-progress-circular", {
                staticClass: "primary--text",
                attrs: { size: 70, width: 1, indeterminate: "" }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "vue-frame fill-height" }, [
        _vm._v("\n    " + _vm._s(_vm.socketConnected) + "\n    "),
        _c(
          "div",
          { ref: "iconeClientPointer", staticClass: "iconeClientPointer" },
          [
            _c("div", { staticClass: "pointerNameUser" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.datasPupitreVisiteur.visiteurID) +
                  "\n      "
              )
            ])
          ]
        ),
        _vm._v(" "),
        _c("div", { ref: "ClickPointer", staticClass: "ClickPointer" }),
        _vm._v(" "),
        _c("div", { staticClass: "fill-height" }, [
          _vm.cobrowsingAlertStatus
            ? _c(
                "div",
                { staticClass: "dialogueIframe" },
                [
                  _c(
                    "v-card",
                    { staticClass: "txtCenterCobrowsing" },
                    [
                      _c(
                        "v-card-title",
                        { staticClass: "primary white--text subheading" },
                        [_vm._v(_vm._s(_vm.$t("visitorCloseCobrowsing")))]
                      ),
                      _vm._v(" "),
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-card-actions",
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "blue--text darken-1",
                              attrs: { flat: "" },
                              on: {
                                click: function($event) {
                                  return _vm.closeCobrowsing()
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.txtBtCobrowsing))]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.cobrowsingMenuActif
            ? _c("div", { staticClass: "maskIframe" })
            : _vm._e(),
          _vm._v(" "),
          _c("iframe", {
            ref: "iframeClientView",
            staticClass: "ClientView",
            attrs: { id: "ClientView_" + _vm.datasVisiteur.placePupitre },
            on: {
              mousemove: _vm.myMouseCoordinates,
              scroll: _vm.myScrollTop,
              click: _vm.myClickMouse,
              keyup: _vm.myKeyPRESS
            }
          })
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-49c32954", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49c32954","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheebox/WzCobrowsingClient.vue
// module id = null
// module chunks = 